export enum BettingOptionsFormat {
    DECIMAL = 'decimal',
    AMERICAN = 'american',
    FRACTIONAL = 'fractional',
    HONGKONG = 'hongkong',
}

export const availableOddsFormats = Object.values(BettingOptionsFormat);
